module.exports = __webpack_public_path__ + "static/fiLighthouse2.06f8dee7.jpg";